// System Prompt Management Module
// Handles fetching and saving system prompts from/to the API

import { CONFIG } from '../../config.js';

const API_BASE = CONFIG.WS_API_BASE;

// Show status message in the system prompt tab
function showStatus(message, type) {
    const statusMessage = document.getElementById('statusMessage');
    if (statusMessage) {
        statusMessage.textContent = message;
        statusMessage.className = `status-message ${type}`;

        if (type === 'success') {
            setTimeout(() => {
                statusMessage.className = 'status-message';
            }, 3000);
        }
    }
}

// Fetch current system prompt from server
export async function fetchSystemPrompt() {
    const systemPromptTextarea = document.getElementById('systemPrompt');
    if (!systemPromptTextarea) return;

    try {
        const response = await fetch(`${API_BASE}/system-prompt`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        systemPromptTextarea.value = data.system_prompt || '';
    } catch (error) {
        showStatus((window.i18n?.t('settings.systemPrompt.loadError') || 'Error loading system prompt') + ': ' + error.message, 'error');
        systemPromptTextarea.value = '';
    }
}

// Save system prompt to server
export async function saveSystemPrompt() {
    const systemPromptTextarea = document.getElementById('systemPrompt');
    const saveBtn = document.getElementById('saveBtn');
    if (!systemPromptTextarea) return;
    const newPrompt = systemPromptTextarea.value.trim();

    if (!newPrompt) {
        showStatus(window.i18n?.t('settings.systemPrompt.emptyError') || 'System prompt cannot be empty!', 'error');
        return;
    }

    if (saveBtn) {
        saveBtn.disabled = true;
        saveBtn.textContent = window.i18n?.t('common.saving') || 'Saving...';
    }

    try {
        const response = await fetch(`${API_BASE}/system-prompt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ system_prompt: newPrompt })
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        showStatus(window.i18n?.t('settings.systemPrompt.saveSuccess') || '✓ System prompt saved successfully!', 'success');

        // Auto-close modal after 1.5 seconds
        setTimeout(() => {
            const settingsModal = document.getElementById('settingsModal');
            if (settingsModal) {
                settingsModal.classList.remove('show');
            }
        }, 1500);

    } catch (error) {
        showStatus((window.i18n?.t('settings.systemPrompt.saveError') || 'Error saving') + ': ' + error.message, 'error');
    } finally {
        if (saveBtn) {
            saveBtn.disabled = false;
            saveBtn.textContent = window.i18n?.t('common.save') || 'Save';
        }
    }
}

// Initialize system prompt module
export function initSystemPrompt() {
    const saveBtn = document.getElementById('saveBtn');
    if (saveBtn) {
        saveBtn.addEventListener('click', saveSystemPrompt);
    }

    // Load system prompt on page load
    window.addEventListener('load', () => {
        fetchSystemPrompt();
    });
}
